"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shallow = exports.mount = void 0;
const react_1 = __importDefault(require("react"));
const enzyme_1 = require("enzyme");
const styled_components_1 = require("styled-components");
const react_router_1 = require("react-router");
const getThemeProvider = () => _ref => {
  let {
    children
  } = _ref;
  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: {}
  }, children);
};
const mount = function (component) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let withRouter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let routerProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const wrappedComponent = withRouter ? react_1.default.createElement(react_router_1.MemoryRouter, Object.assign({}, routerProps), component) : component;
  return (0, enzyme_1.mount)(wrappedComponent, Object.assign(Object.assign({}, options), {
    wrappingComponent: getThemeProvider()
  }));
};
exports.mount = mount;
const shallow = function (component) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let withRouter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let routerProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const wrappedComponent = withRouter ? react_1.default.createElement(react_router_1.MemoryRouter, Object.assign({}, routerProps), component) : component;
  return (0, enzyme_1.shallow)(wrappedComponent, Object.assign(Object.assign({}, options), {
    wrappingComponent: getThemeProvider(),
    disableLifecycleMethods: true
  })).dive().dive();
};
exports.shallow = shallow;